// extracted by mini-css-extract-plugin
module.exports = {"header":"HeaderWrapper_header__11FQS"};